import { useMutation, useQueryClient } from '@tanstack/react-query'
import { invoiceFetch as apiFetch } from '@/api/client'
import { useAuth } from '@/hooks/use-auth'
import { invoiceKeys } from '@/features/invoices/keys'
import { USE_MOCK_AP_INVOICES } from '../mock'
import type { ApInvoiceThreadInput } from '../types'
import type { ApInvoiceThread } from '../view-models'

export function useCreateInvoiceThread(uuid: string) {
  const { getAccessToken } = useAuth()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: ApInvoiceThreadInput) => {
      if (USE_MOCK_AP_INVOICES) {
        return {
          id: 9885,
          uuid: `mock-ap-thread-${Date.now()}`,
          entity_type: 'ap_invoice',
          entity_id: 9001,
          ap_invoice_id: 9001,
          purchase_order_id: null,
          subject: body.subject || 'AP invoice thread',
          status: 'draft',
          graph_conversation_id: null,
          recipient_email: body.recipient_email || 'accounting@shopusars.com',
          recipient_name: body.recipient_name || 'USA-RS Accounting',
          cc_emails: JSON.stringify(body.cc_emails ?? []),
          last_activity_at: new Date().toISOString(),
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
          follow_up_at: null,
          follow_up_count: 0,
          max_follow_ups: 2,
          messages: [],
        } satisfies ApInvoiceThread
      }
      const token = await getAccessToken()
      if (!token) throw new Error('Failed to acquire access token')
      return apiFetch<ApInvoiceThread>(token, `/dashboard/ap-invoices/${uuid}/threads/create`, {
        method: 'POST',
        json: body,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: invoiceKeys.all })
      queryClient.invalidateQueries({
        queryKey: invoiceKeys.detail(uuid),
      })
    },
  })
}
